import React, { useState, useRef } from 'react';
import useAppState, { useAppDispatch } from '~/appState';
import { openMenu } from '~/actions/global';
import { Link } from 'react-router-dom';
import './styles.scss';
import LogoutAskModal from '~/components/modals/logoutAskModal';
import { logout } from '~/actions/account';

// helpers
import { trackGTM } from '~/utils';
import { usePermission, useOutsideClick } from '~/hooks';

// constants
import {
  AccountType,
  TRACK_GTM,
  GetImpersonatedUser,
  CAREGIVER_MENU,
  PATIENT_MENU,
  IMPERSONATED_MENU,
} from '~/consts';

function MenuLink(props) {
  const { children, ...rest } = props;
  const dispatch = useAppDispatch();
  return (
    <Link {...rest} onClick={() => dispatch(openMenu(false))}>
      {children}
    </Link>
  );
}

function Menu() {
  const {
    global: { isOpened, isLogin, userId, accountType },
  } = useAppState();
  const dispatch = useAppDispatch();
  const { allowedUrls } = usePermission();
  const [isLogout, setIsLogout] = useState(false);
  const userInfo = GetImpersonatedUser();
  const menuRef = useRef(null);

  useOutsideClick(menuRef, () => {
    if (menuRef.current.classList.contains('navigation-is-visible')) {
      dispatch(openMenu(false));
    }
  });

  const handleLogout = () => {
    dispatch(openMenu(false));
    setIsLogout(true);
  };

  function handleConfirmLogout() {
    setIsLogout(false);

    dispatch(logout());
    localStorage.removeItem('authToken');

    trackGTM(TRACK_GTM.LOGOUT, {
      userId,
    });

    window.open('/login', '_self');
  }

  function handleCloseLogout() {
    setIsLogout(false);
  }

  const viewType = userInfo.isImpersonated ? userInfo.accountType : accountType;

  let menuItems = [];

  if (userInfo.isImpersonated) {
    menuItems = IMPERSONATED_MENU.filter(({ url }) =>
      allowedUrls.includes(url)
    );
  } else if (viewType == AccountType.CareGiver) {
    menuItems = CAREGIVER_MENU;
  } else if (viewType == AccountType.Patient) {
    menuItems = PATIENT_MENU;
  }

  return (
    <div
      className={`page-menu navbar-collapse ${
        isOpened ? 'navigation-is-visible' : ''
      }`}
      ref={menuRef}
    >
      <ul className="main-menu">
        {menuItems.map((item) => (
          <li key={item.title}>
            <MenuLink to={`/${item.url}`}>{item.title}</MenuLink>
          </li>
        ))}
        {isLogin && (
          <li>
            <div
              className="item-logout"
              onClick={() => handleLogout()}
              role="button"
              tabIndex={0}
            >
              Log Out
            </div>
          </li>
        )}
      </ul>
      <LogoutAskModal
        isOpen={isLogout}
        confirm={handleConfirmLogout}
        close={handleCloseLogout}
      />
    </div>
  );
}

export default Menu;
